/**
 * An application's support ticket prefix, as typed (Jon, 2026-09-27).
 *
 * The field is just the letters; the hyphen is assumed. So a typed hyphen is
 * dropped rather than refused, and case does not matter: `key-` is `KEY`.
 * Anything else that is not two to four letters is left as typed, for the form
 * to say what is wrong, because a prefix quietly changed from what was typed is
 * a reference nobody expects. The auth service applies the same rule.
 */
export function cleanTicketPrefix(raw: string): string {
  return raw.trim().toUpperCase().replace(/-+$/, '');
}

/** Why a cleaned prefix cannot be saved, or null when it can (blank included). */
export function ticketPrefixProblem(prefix: string): string | null {
  if (prefix === '') return null;
  if (!/^[A-Z]{2,4}$/.test(prefix)) return '2 to 4 letters, no digits or hyphen.';
  if (prefix === 'RW') return 'RW is the platform’s own prefix.';
  return null;
}
